module.exports = __webpack_public_path__ + "static/media/img13.c384747e.jpg";